module.exports = __webpack_public_path__ + "static/media/concept_sketch_for_brewery_mural_2017.ac94f19b.webp";